// extracted by mini-css-extract-plugin
export var contactBox = "footer-module--contact-box--b7c7f";
export var contactMe = "footer-module--contact-me--50085";
export var envelope = "footer-module--envelope--78169";
export var icon = "footer-module--icon--496d7";
export var mailButton = "footer-module--mail-button--66f93";
export var mailContainer = "footer-module--mail-container--69cd6";
export var pageFooter = "footer-module--page-footer--3f13d";